export enum REMINDER_TYPE {
  // Sempre no dia de vencimento
  ON_DUE_DATE = 'ON_DUE_DATE',

  // 3 dias antes + no dia
  THREE_DAYS_BEFORE_AND_ON_DUE = 'THREE_DAYS_BEFORE_AND_ON_DUE',

  // 5 dias antes + no dia
  FIVE_DAYS_BEFORE_AND_ON_DUE = 'FIVE_DAYS_BEFORE_AND_ON_DUE',

  // Sempre no dia X e no dia (configurável)
  CUSTOM_DAYS_BEFORE_AND_ON_DUE = 'CUSTOM_DAYS_BEFORE_AND_ON_DUE',

  // Sempre no dia (apenas no dia de vencimento)
  ONLY_ON_DUE_DATE = 'ONLY_ON_DUE_DATE',
}
